import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { parseNavbarContent } from '../utils/navbarContent';
import { createContentCache } from '../utils/contentCache';

const navbarCache = createContentCache();

export const useNavbarContent = () => {
  const [content, setContent] = useState(() => navbarCache.getCached());
  const [isLoading, setIsLoading] = useState(() => !navbarCache.getCached());
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const parsed = await navbarCache.load(async () => {
          const page = await getPublicPage('global-layout');
          return parseNavbarContent(page);
        });

        if (!isMounted) {
          return;
        }

        setContent(parsed);
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { content, isLoading, error };
};
